import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { FaRocket, FaTimes, FaExternalLinkAlt } from 'react-icons/fa';
import CountdownTimer from '../ui/CountdownTimer';
import { BBT_CONFIG } from '../../config/bbt.js';

const BBTLaunchBanner = ({ 
  variant = 'default', // 'default', 'compact', 'floating'
  showCloseButton = true,
  className = ''
}) => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  const contractAddress = '0x0354a58290E141b241d5b32AE02D581289f286b7';
  // La logique de date est maintenant centralisée sur la page BBT.
  // const phaseOneDate = new Date();
  // phaseOneDate.setMonth(phaseOneDate.getMonth() + 1);

  const baseClasses = "relative overflow-hidden";
  const variantClasses = {
    default: "bg-gradient-to-r from-[#00A04A]/90 to-[#7AC142]/90 backdrop-blur-sm border border-[#7AC142]/30 rounded-xl p-6",
    compact: "bg-gradient-to-r from-[#00A04A]/80 to-[#7AC142]/80 backdrop-blur-sm border border-[#7AC142]/20 rounded-lg p-4",
    floating: "fixed bottom-4 right-4 z-50 bg-gradient-to-r from-[#00A04A]/95 to-[#7AC142]/95 backdrop-blur-xl border border-[#7AC142]/40 rounded-2xl p-4 shadow-2xl max-w-sm"
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: variant === 'floating' ? 100 : -20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: variant === 'floating' ? 100 : -20 }}
        className={`${baseClasses} ${variantClasses[variant]} ${className}`}
      >
        {/* Effets de fond */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#00A04A]/10 to-[#7AC142]/10 animate-pulse"></div>
        
        {/* Bouton de fermeture */}
        {showCloseButton && (
          <button
            onClick={() => setIsVisible(false)}
            className="absolute top-2 right-2 text-white/70 hover:text-white transition-colors p-1"
          >
            <FaTimes size={14} />
          </button>
        )}

        <div className="relative z-10">
          {variant === 'default' && (
            <div className="text-center">
              <div className="flex items-center justify-center mb-3">
                <FaRocket className="text-white mr-2 animate-bounce" />
                <span className="text-white font-bold text-lg">Phase 0 Lancée : BBT est LIVE !</span>
                <FaRocket className="text-white ml-2 animate-bounce" />
              </div>
              
              <p className="text-white/90 mb-4 text-sm">
                Le Baobab Token est disponible sur BSC Mainnet. 
                Découvrez les fonctionnalités de la {BBT_CONFIG.phase} et préparez-vous pour la suite !
              </p>
              
              <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
                <Link
                  to="/bbt"
                  className="px-6 py-2 bg-white text-[#00A04A] rounded-lg font-semibold hover:bg-gray-100 transition-colors flex items-center gap-2"
                >
                  <FaRocket size={14} />
                  Voir la Roadmap
                </Link>
                
                <a
                  href={BBT_CONFIG.urls.pancakeSwap}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-6 py-2 bg-[#FF6F00] text-white rounded-lg font-semibold hover:bg-[#E55A00] transition-colors flex items-center gap-2"
                >
                  <FaExternalLinkAlt size={12} />
                  Acheter
                </a>
              </div>
            </div>
          )}

          {variant === 'compact' && (
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <FaRocket className="text-white mr-2" />
                <span className="text-white font-semibold text-sm">
                  BBT est LIVE ! Découvrez la roadmap.
                </span>
              </div>
              <Link
                to="/bbt"
                className="px-4 py-1 bg-white text-[#00A04A] rounded text-sm font-semibold hover:bg-gray-100 transition-colors ml-4"
              >
                Découvrir
              </Link>
            </div>
          )}

          {variant === 'floating' && (
            <div className="text-center">
              <div className="flex items-center justify-center mb-2">
                <FaRocket className="text-white mr-1 animate-bounce" size={16} />
                <span className="text-white font-bold text-sm">BBT LIVE !</span>
              </div>
              
              <p className="text-white/90 mb-3 text-xs">
                Token BBT maintenant disponible sur BSC
              </p>
              
              <div className="space-y-2">
                <Link
                  to="/bbt"
                  className="block w-full px-4 py-2 bg-white text-[#00A04A] rounded-lg font-semibold hover:bg-gray-100 transition-colors text-sm"
                >
                  Gérer BBT
                </Link>
                
                <a
                  href={BBT_CONFIG.urls.bscScan}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full px-4 py-2 bg-[#1B263B]/50 text-white rounded-lg font-semibold hover:bg-[#1B263B]/70 transition-colors text-sm flex items-center justify-center"
                >
                  Voir Contrat <FaExternalLinkAlt className="ml-1" size={10} />
                </a>
              </div>
            </div>
          )}
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default BBTLaunchBanner; 